@if (component$ | async; as component) {
  @if (approvedItems$ | async; as items) {
    <div class="carousel-wrapper">
      <div class="container">
        @if (title$ | async; as title) {
          <div class="info-component">
            <div>
              <div class="h2-component">{{title}}</div>
            </div>
          </div>
        }
        @if ((isMobile() | async)) {
          <cx-carousel
            [items]="items"
            [template]="carouselItem"
            [animation]="animation"
            [hideIndicators]="true"
            [hideButtons]="false"
            [itemWidth]="'50%'"
            >
          </cx-carousel>
        } @else {
          <cx-carousel
            [items]="items"
            [template]="carouselItem"
            [itemWidth]="'300px'"
            [hideIndicators]="true"
            [hideButtons]="false"
            [animation]="animation"
            >
          </cx-carousel>
        }
      </div>
    </div>
  }
}

<ng-template #carouselItem let-item="item">
  @if (item) {
    <app-custom-product-item [item]="item" [pdp]="false"></app-custom-product-item>
  }
</ng-template>
